import {
  DriverTripDetailsResponse,
  IAcceptTripRequest,
  IDeletedResquest,
  ISendTripRequest,
  ISendTripUpdateRequest,
  TripSummary,
  TripsPage,
} from "@types";

import { store } from "@store";
import api from ".";

export const fetchTripsList = async (
  page: number,
  size: number,
  search?: string,
  sortB?: string,
  fieldSort?: string,
  filterByType?: string,
  startDate?: string,
  endDate?: string,
  options?: { signal?: AbortSignal }
) => {
  const params = new URLSearchParams();
  const sizeSend = size > 10 ? size : 10;
  params.append("size", sizeSend.toString());

  if (page >= 0) {
    params.append("page", page.toString());
  }

  const names = {
    name: "driverName",
    origin: "originName",
    destination: "destinationName",
    stops: "quantityStops",
    distance: "distance",
    duration: "duration",
    vehicle: "assetName",
    scheduling: "scheduling",
    status: "status",
    tripStatus: "tripStatus",
  };

  if (search) {
    params.append("search", search);
  }

  if (sortB) {
    params.append("order", sortB.toUpperCase());
  }


  if (fieldSort && fieldSort in names) {
    params.append("orderBy", names[fieldSort as keyof typeof names]);
  }

  if (startDate) {
    params.append("initial_date", startDate);
  }

  if (endDate) {
    params.append("final_date", endDate);
  }

  switch (filterByType?.toUpperCase()) {
    case undefined:
    case "ALL":
      break;
    case "ACCEPTED":
      params.append("status", "SCHEDULED");
      params.append("statusAccept", "ACCEPTED");
      break;
    case "PROPOSED":
      params.append("status", "PROPOSED");
      params.append("statusAccept", "PROPOSED");
      break;
    case "PENDING":
      params.append("status", "SCHEDULED");
      params.append("statusAccept", "PENDING");
      break;
    case "REFUSED":
      params.append("status", "FINISHED");
      params.append("statusAccept", "REFUSED");
      break;
    case "CANCELED":
      params.append("status", "FINISHED");
      params.append("statusAccept", "CANCELED");
      break;
    case "ACOMPLISHED":
      params.append("status", "FINISHED");
      params.append("statusAccept", "ACCEPTED");
      break;
    default:
      break;
  }

  const response = await api.get(`v2/routes/trips?${params.toString()}`, options);
  return response.data;
};

export const fetchTripsListOnGoing = async (
  page: number,
  size: number,
  search?: string,
  sortB?: string,
  fieldSort?: string,
  statusFilter?: string,
  options?: { signal?: AbortSignal }
) => {
  const params = new URLSearchParams();
  params.append("size", size.toString());

  if (page) {
    const pageN = page - 1;
    params.append("page", pageN.toString());
  }

  const names = {
    name: "drivername",
    dateStarted: "datestarted",
    status: "routeStatus",
    statusTrip: "deliveryStatus",
    progress: "progress",
    duration: "eta",
    destination: "destination",
    vehicle: "vehicle",
    routeSuggestion: 'routeSuggestion',               
  };

  if (search) {
    params.append("search", search);
  }

  if (sortB) {
    params.append("order", sortB.toUpperCase());
  }

  if (fieldSort && fieldSort in names) {
    params.append("orderBy", names[fieldSort as keyof typeof names]);
  }

  if (statusFilter && statusFilter.trim() !== "") {
    if (statusFilter.toUpperCase() === "STARTED") {
      params.append("statusFilter", "ONROUTE,ESTIMATED");
    } else {
      params.append("statusFilter", statusFilter);
    }
  }
  const userIdAmity = store.getState().login.userIdAmity;
  const response = await api.get(`v2/routes/started-status?${params.toString()}`, {
    ...options, headers: {
      'unique-profile-id': userIdAmity,
    }
  });
  return response.data;
};

export const getSuggestedRoute = async (tripId: string) => {
  const response = await api.get(`v2/suggested-route/${tripId}/trip`);
  return response.data;
}

export const acceptTrip = async (body: IAcceptTripRequest) => {
  const response = await api.post(`v2/suggested-route/suggestion-choice`, body);
  return response.data;
};

export const sendTrip = async (body: ISendTripRequest, routeId: string) => {
  const userIdAmity = store.getState().login.userIdAmity;
  const response = await api.post(`v2/routes/rio/send/${routeId}`, body, {
    headers: {
      "unique-profile-id": userIdAmity || "",
    },
  });
  return response.data;
};

export const sendTripCustom = async (body: ISendTripRequest, routeId: string) => {
  const userIdAmity = store.getState().login.userIdAmity;
  const response = await api.post(`v2/routes/rio/send/trip/${routeId}`, body, {
    headers: {
      "unique-profile-id": userIdAmity || "",
    },
  });
  return response.data;
};

export const sendTripUpdateCopy = async (body: ISendTripUpdateRequest, tripId: string) => {
  const userIdAmity = store.getState().login.userIdAmity;
  const response = await api.post(`/v2/routes/rio/send/trip/${tripId}/copy`, body, {
    headers: {
      "unique-profile-id": userIdAmity || "",
    },
  });
  return response.data;
};

export const fetchCanceledTrip = async (body: IDeletedResquest, id: string) => {
  const response = await api.put(`v2/routes/trips/${id}`, body);
  return response.data;
};

export const sendStatusSchulingTrip = async (body: { tripId: string; status: string }) => {
  const response = await api.post(`v2/routes/trips/trip-date-decision`, body);
  return response.data;
};

export const fetchDetailsTripOnGoing = async (tripId?: string) => {
  const response = await api.get(`v2/routes/started-status/${tripId}`);
  return response.data;
};

export async function fetchTripDetailsByTripId(rioId: string, tripId: string): Promise<DriverTripDetailsResponse> {
  const response = await api.get(`v2/routes/trips/details/${rioId}/trips/${tripId}`);
  return response.data.data.result;
}

/**
 * Lista as paradas não programadas de uma viagem em rota.
 *
 * Endpoint backend: /rio/{routeId}/trips/{tripId}/stops/unplanned
 * Mantendo o padrão atual de prefixo dos demais endpoints de rota/viagem,
 * o caminho completo fica sob /v2/routes/trips.
 */
export const fetchUnplannedStops = async (routeId: string, tripId: string) => {
  const response = await api.get(`v2/routes/trips/rio/${routeId}/trips/${tripId}/stops/unplanned`);
  return response.data;
};

const names = {
  "travelDate": "travelDate",
  "name": "driverName",
  "co2Emission": "co2Emission",
  "fuelConsumption": "fuelConsumption",
  "distanceTraveled": "distanceTraveled",
  "timeTotal": "timeTotal",
  "timeStops": "timeStops",
  "originDestination": "originDestination",
  "vehicle": "assetName",
};

export const fetchLastTripsByDrivers = async (
  search?: string,
  pageIndex = 1,
  size = 10,
  initialDate?: string,
  finalDate?: string,
  sortB?: string,
  fieldSort?: string
): Promise<TripsPage> => {
  const params: any = { page: pageIndex, size };
  if (search) params.search = search;
  if (initialDate) params.initial_date = initialDate;
  if (finalDate) params.final_date = finalDate;
  if (sortB) {
    params.order = sortB.toUpperCase();
  }

  if (size < 10) {
    params.size = 10;
  }


  if (fieldSort && fieldSort in names) {
    params.orderBy = names[fieldSort as keyof typeof names];
  }

  const response = await api.get("/v2/routes/trips/drivers/trips/finished", { params });
  const result = response.data.data.result;

  return {
    trips: result.trips as TripSummary[],
    page: result.page,
    totalPages: result.totalPages,
    totalTrips: result.totalTrips,
    totalCo2Emission: result.totalCo2Emission,
    totalTime: result.totalTime,
    totalDistance: result.totalDistance,
    totalFuelConsumption: result.totalFuelConsumption,
    totalIdleTime: result.totalIdleTime,
    plannedDistance: result.plannedDistance,
    plannedFuelConsumption: result.plannedFuelConsumption,
    plannedCo2Emission: result.plannedCo2Emission,
    plannedTime: result.plannedTime,
    initialDate: result.initialDate,
    finalDate: result.finalDate
  };
};
